import React, { Component } from "react";
import styles from "./Layouts.local.scss";
import classnames from "classnames";
import { ComponentFactory } from "../Components/ComponentFactory";
import {
  hasExplanation,
  checkAndGetExplanations,
  checkForComments
} from "Utils";

//  _________________________________
// |                                 |
// |                                 |
// |                                 |
// |                                 |
// |                                 |
// |_________________________________|

class Layout1 extends Component {
  render() {
    const {
      slideId,
      selectedComponent,
      layoutData: { components },
      componentsBackground,
      isResponsive,
      isComposition,
      isPresentation,
      isPreparePresentation,
      comments,
      explanations,
      indicators,
      lng
    } = this.props;

    const customBackground = {
      background: componentsBackground
    };

    return (
      <div className={`row ${styles.layout}`}>
        <div
          className={classnames(
            isResponsive ? "large-12 medium-12 small-12" : "small-12",
            styles.component_block,
            styles.flex_container,
            styles.align_container,
            isComposition === false &&
              components[1] !== undefined &&
              (selectedComponent === components[1].componentId
                ? styles.gradient_border
                : "")
          )}
        >
          <div
            className={classnames(
              styles.component_container,
              styles.container_xl_height
            )}
            style={customBackground}
          >
            {/********** Component n°1 ********/}
            <ComponentFactory
              component={components[1]}
              layoutProps={{
                customBackground: customBackground,
                containerHeight: 430,
                scaleComponent: true,
                minWidth: true
              }}
              ComponentCase={"1"}
              isComposition={isComposition}
              isPresentation={isPresentation}
              isPreparePresentation={isPreparePresentation}
              hasComments={
                isPresentation &&
                checkForComments(components[1], comments, slideId)
              }
              indicatorsExplanation={
                isPresentation || isComposition
                  ? checkAndGetExplanations(
                      components[1],
                      explanations,
                      indicators,
                      lng
                    )
                  : null
              }
              hasExplanation={
                (isPresentation || isComposition) &&
                hasExplanation(components[1])
              }
              {...this.props}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Layout1;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Layouts/Layout1.js